module.exports = __webpack_public_path__ + "media/src/assets/images/lps-life_event_pc-02c1aee16a2204b935ca87f625e43ced.png";